import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

import type { ApprovalSequenceType } from '../../types/singleFlow.js';
import ApprovalSequence from '../ApprovalSequence.jsx';

type Props = {
  approvalSequence: ApprovalSequenceType | null;
  onClose: () => void;
};

const PreviewFlowModal: FC<Props> = ({ approvalSequence, onClose }) => {
  const { t } = useTranslation('@myn/approval_v2');

  return (
    <Dialog modal onOpenChange={onClose} open={Boolean(approvalSequence)}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s" aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle>{t('Preview')}</DialogTitle>
          </DialogHeader>
          <DialogContent>
            {approvalSequence ? (
              <div className="grid w-full gap-4">
                <ApprovalSequence items={approvalSequence} />
              </div>
            ) : null}
          </DialogContent>
          <DialogFooter>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={onClose}
              aria-label="Close the modal"
              data-dd-action-name="Close the modal"
            >
              {t('Got it')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};

export default PreviewFlowModal;
